import { useLocation } from "react-router-dom";

import { locate } from "@/lib/deal-capture/paths";
import type { SidebarSlotProps } from "@/lib/module-registry";

import { AreaPicker } from "./AreaPicker";
import { ContractPicker } from "./ContractPicker";
import { DealPicker } from "./DealPicker";
import { EntityPicker } from "./EntityPicker";
import { FlowToggle } from "./FlowToggle";

/**
 * Deal Capture's sidebar header, under the module switcher: the Area picker,
 * then what the area scopes to. Deals adds the Integrated / Non-Integrated
 * toggle and the Deal picker; Contracts the Contract picker; Entities the
 * Entity picker. Deleted Deals has no picker.
 *
 * Every picker is the shared `ScopePicker`, whose search box mounts with the
 * dropdown and takes focus each time it opens.
 */
export function DealCaptureSidebarHeader({ onClose }: SidebarSlotProps) {
  const { pathname } = useLocation();
  const { area } = locate(pathname);

  return (
    <div className="flex flex-col gap-2">
      <AreaPicker onClose={onClose} />
      {area === "deals" && (
        <>
          <FlowToggle onClose={onClose} />
          <DealPicker onClose={onClose} />
        </>
      )}
      {area === "contracts" && <ContractPicker onClose={onClose} />}
      {area === "entities" && <EntityPicker onClose={onClose} />}
    </div>
  );
}
